import React from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));
  const navigate = useNavigate();
  return (
    <>
      <main className=" container flex-1 overflow-x-hidden overflow-y-auto">
        {adminToken === null ? (
          <div className="max-w-lg mx-auto my-10 mt-20 bg-white p-8 rounded-xl shadow shadow-slate-300">
            <h1 className="text-4xl font-medium">
              To access other pages, please login.
            </h1>

            <form action="" className="my-10">
              <div className="flex flex-col space-y-5">
                <button
                  onClick={() => {
                    navigate("/admin/login");
                  }}
                  className="w-full py-3 font-medium text-white bg-indigo-600 hover:bg-indigo-500 rounded-lg border-indigo-500 hover:shadow inline-flex space-x-2 items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                    />
                  </svg>
                  <span>Login</span>
                </button>
              </div>
            </form>
          </div>
        ) : (
          <div className="container mx-auto px-6 py-3">
            <h3 className="text-gray-700 text-3xl font-bold">Dashboard</h3>
            <hr />
            <div className="mt-3">
              <div className="flex flex-wrap -mx-6">
                <div className="w-full px-7 mb-10 sm:w-1/2 xl:w-1/3">
                  <div className="flex items-center px-5 py-6 shadow-sm rounded-md bg-indigo-500">
                    <div className="p-3">
                      <i className="fa-solid fa-calendar-plus h-8 w-8 text-white text-3xl"></i>
                    </div>

                    <div className="mx-5">
                      <h4 className="text-2xl font-semibold text-white">4</h4>
                      <div className="text-white">Up-Comming Exams</div>
                    </div>
                  </div>
                </div>
                <div className="w-full mt-6 mb-10 px-7 sm:w-1/2 xl:w-1/3 xl:mt-0">
                  <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-green-500">
                    <div className="p-3">
                      <i className="fa-solid fa-check h-8 w-8 text-white text-3xl"></i>
                    </div>

                    <div className="mx-5">
                      <h4 className="text-2xl font-semibold text-white">4</h4>
                      <div className="text-white">Exam Completed</div>
                    </div>
                  </div>
                </div>
                <div className="w-full mt-6 px-6 mb-10 sm:w-1/2 xl:w-1/3 sm:mt-0">
                  <div className="flex items-center px-5 py-6 shadow-sm rounded-md  bg-orange-500">
                    <div className="p-3">
                      <i className="fa-solid fa-calendar h-8 w-8 text-white text-3xl"></i>
                    </div>

                    <div className="mx-5">
                      <h4 className="text-2xl font-semibold text-white">4</h4>
                      <div className="text-white">On-Going Exams</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8"></div>
          </div>
        )}
      </main>
    </>
  );
};

export default Home;
